/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Notifications_Totalsubscribed1Inputs */

const id_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total topik yang dilanggani: ${i?.count}`)
};

const ms_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Jumlah topik dilanggan: ${i?.count}`)
};

const da_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Samlede abonnerede emner: ${i?.count}`)
};

const de_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abonnierte Themen insgesamt: ${i?.count}`)
};

const en_us2_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total subscribed topics: ${i?.count}`)
};

const es_es2_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total de temas suscritos: ${i?.count}`)
};

const es_mx2_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total de temas suscritos: ${i?.count}`)
};

const fil_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kabuuang naka-subscribe na paksa: ${i?.count}`)
};

const fr_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total des sujets abonnés : ${i?.count}`)
};

const it_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Argomenti totali sottoscritti: ${i?.count}`)
};

const hu_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Összes feliratkozott témakör: ${i?.count}`)
};

const nl_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Totaal geabonneerde onderwerpen: ${i?.count}`)
};

const no_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Totalt antall abonnerte emner: ${i?.count}`)
};

const pl_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Łączna liczba subskrybowanych tematów: ${i?.count}`)
};

const pt_br2_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total de tópicos inscritos: ${i?.count}`)
};

const pt_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total de tópicos subscritos: ${i?.count}`)
};

const ro_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total subiecte abonate: ${i?.count}`)
};

const fi_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tilattuja aiheita yhteensä: ${i?.count}`)
};

const sv_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Totalt antal prenumererade ämnen: ${i?.count}`)
};

const vi_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tổng số chủ đề đã đăng ký: ${i?.count}`)
};

const tr_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Abone olunan toplam konu: ${i?.count}`)
};

const cs_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Celkem odebíraných témat: ${i?.count}`)
};

const bg_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Общо абонирани теми: ${i?.count}`)
};

const ru_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Всего подписанных тем: ${i?.count}`)
};

const uk_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Усього підписаних тем: ${i?.count}`)
};

const ar_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`إجمالي الموضوعات المشترك فيها: ${i?.count}`)
};

const hi_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`कुल सब्सक्राइब किए गए विषय: ${i?.count}`)
};

const th_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`หัวข้อที่สมัครรับทั้งหมด: ${i?.count}`)
};

const ja_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`購読中のトピック数：${i?.count}`)
};

const zh_cn2_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已订阅主题总数：${i?.count}`)
};

const zh_hant1_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`已訂閱主題總數：${i?.count}`)
};

const ko_notifications_totalsubscribed1 = /** @type {(inputs: Notifications_Totalsubscribed1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`총 구독 주제: ${i?.count}`)
};

/**
* | output |
* | --- |
* | "Total subscribed topics: {count}" |
*
* @param {Notifications_Totalsubscribed1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const notifications_totalsubscribed1 = /** @type {((inputs: Notifications_Totalsubscribed1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Totalsubscribed1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_notifications_totalsubscribed1(inputs)
	if (locale === "ms") return ms_notifications_totalsubscribed1(inputs)
	if (locale === "da") return da_notifications_totalsubscribed1(inputs)
	if (locale === "de") return de_notifications_totalsubscribed1(inputs)
	if (locale === "en-US") return en_us2_notifications_totalsubscribed1(inputs)
	if (locale === "es-ES") return es_es2_notifications_totalsubscribed1(inputs)
	if (locale === "es-MX") return es_mx2_notifications_totalsubscribed1(inputs)
	if (locale === "fil") return fil_notifications_totalsubscribed1(inputs)
	if (locale === "fr") return fr_notifications_totalsubscribed1(inputs)
	if (locale === "it") return it_notifications_totalsubscribed1(inputs)
	if (locale === "hu") return hu_notifications_totalsubscribed1(inputs)
	if (locale === "nl") return nl_notifications_totalsubscribed1(inputs)
	if (locale === "no") return no_notifications_totalsubscribed1(inputs)
	if (locale === "pl") return pl_notifications_totalsubscribed1(inputs)
	if (locale === "pt-BR") return pt_br2_notifications_totalsubscribed1(inputs)
	if (locale === "pt") return pt_notifications_totalsubscribed1(inputs)
	if (locale === "ro") return ro_notifications_totalsubscribed1(inputs)
	if (locale === "fi") return fi_notifications_totalsubscribed1(inputs)
	if (locale === "sv") return sv_notifications_totalsubscribed1(inputs)
	if (locale === "vi") return vi_notifications_totalsubscribed1(inputs)
	if (locale === "tr") return tr_notifications_totalsubscribed1(inputs)
	if (locale === "cs") return cs_notifications_totalsubscribed1(inputs)
	if (locale === "bg") return bg_notifications_totalsubscribed1(inputs)
	if (locale === "ru") return ru_notifications_totalsubscribed1(inputs)
	if (locale === "uk") return uk_notifications_totalsubscribed1(inputs)
	if (locale === "ar") return ar_notifications_totalsubscribed1(inputs)
	if (locale === "hi") return hi_notifications_totalsubscribed1(inputs)
	if (locale === "th") return th_notifications_totalsubscribed1(inputs)
	if (locale === "ja") return ja_notifications_totalsubscribed1(inputs)
	if (locale === "zh-CN") return zh_cn2_notifications_totalsubscribed1(inputs)
	if (locale === "zh-Hant") return zh_hant1_notifications_totalsubscribed1(inputs)
	return ko_notifications_totalsubscribed1(inputs)
});
export { notifications_totalsubscribed1 as "notifications.totalSubscribed" }